import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.patch["Content-Type"] = "application/merge-patch+json";

const authUserManager = {
  getGuest: () => JSON.parse(localStorage.getItem('guest')),
  isEventGuest: (eventId, startAt) => {
    const guest = localStorage.getItem('guest');
    if (!guest) return false;
    const guestObject = JSON.parse(guest);
    return guestObject?.event?.id === eventId && guestObject?.event?.startAt === startAt
  },
  isAdmin: () => {
    const admin = sessionStorage.getItem("authUser");
    if (!admin) return false;
    const adminObject = JSON.parse(admin);
    return adminObject?.role?.includes('ROLE_ADMIN') ?? false;
  },
  getEventGuestId: (eventId) => {
    const guest = localStorage.getItem('guest');
    const parsedGuest = JSON.parse(guest);
    if (parsedGuest?.event?.id === eventId) {
      return parsedGuest.id
    }
    return null;
  },
  getAdminEventId: () => {
    const admin = sessionStorage.getItem('authUser');
    const parsedAdmin = JSON.parse(admin);
    return parsedAdmin?.eventId
  },
  setGuest: (guest) => localStorage.setItem('guest', JSON.stringify(guest)),

  updateUsername(newUsername) {
    const authUser = this.getAuthUser();
    if (authUser) {
      authUser.username = newUsername;
      sessionStorage.setItem("authUser", JSON.stringify(authUser));
    }
  },

  isClubAdmin: () => sessionStorage.getItem("authUser"),
  getAdminId: () => {
    const admin = sessionStorage.getItem("authUser");
    return admin ? JSON.parse(admin).id : null;
  },
  getAuthUser: () => JSON.parse(sessionStorage.getItem("authUser")),
  getToken: () => {
    const user = sessionStorage.getItem("authUser");
    return user ? JSON.parse(user).token : null;
  },
  getId: () => {
    const user = sessionStorage.getItem("authUser");
    return user ? JSON.parse(user).id : null;
  },
  setAuthUser: (authUser) => sessionStorage.setItem("authUser", JSON.stringify(authUser)),
  removeAuthUser: () => sessionStorage.removeItem("authUser"),
};

// Request interceptor to add auth token dynamically
axios.interceptors.request.use(
  function (config) {
    const token = authUserManager.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        if (error.response.data.message === 'Expired JWT Token') {
          authUserManager.removeAuthUser();
          window.location.href = '/login';
        }
        message = error.response.data.message;
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      case 400:
      case 422:
        message = error.response?.data?.violations ?? error.response?.data?.detail;
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    if (data === null || data === undefined) {
      return axios.post(url, null, {
        headers: {
          'Content-Type': undefined
        }
      });
    }
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}

export { APIClient, setAuthorization, authUserManager };
